import { render, staticRenderFns } from "./RegistroDeVehiculos.vue?vue&type=template&id=152885c0"
import script from "./RegistroDeVehiculos.vue?vue&type=script&lang=js"
export * from "./RegistroDeVehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports